import React from 'react'
/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/react'
import PropTypes from 'prop-types'

import {
  CometChatMessageActions,
  CometChatThreadedMessageReplyCount,
  CometChatReadReceipt,
} from '..'
import { CometChatMessageReactions } from '../Extensions'

import { CometChatContext } from '../../../util/CometChatContext'
import { checkMessageForExtensionsData } from '../../../util/common'

import Translator from '../../../resources/localization/translator'
import { theme } from '../../../resources/theme'

import {
  messageContainerStyle,
  messageWrapperStyle,
  messageFileWrapper,
  messageInfoWrapperStyle,
  messageReactionsWrapperStyle,
  iconStyle,
} from './style'

import fileIcon from './resources/file-upload.svg'

class CometChatSenderFileMessageBubble extends React.Component {
  static contextType = CometChatContext

  constructor(props) {
    super(props)

    this.state = {
      isHovering: false,
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const currentMessageStr = JSON.stringify(this.props.message)
    const nextMessageStr = JSON.stringify(nextProps.message)

    if (
      currentMessageStr !== nextMessageStr ||
      this.state.isHovering !== nextState.isHovering
    ) {
      return true
    }
    return false
  }

  handleMouseHover = () => {
    this.setState(this.toggleHoverState)
  }

  toggleHoverState = (state) => {
    return {
      isHovering: !state.isHovering,
    }
  }

  render() {
    let messageReactions = null
    const reactionsData = checkMessageForExtensionsData(
      this.props.message,
      'reactions'
    )
    if (reactionsData) {
      if (Object.keys(reactionsData).length) {
        messageReactions = (
          <div
            css={messageReactionsWrapperStyle()}
            className="message__reaction__wrapper"
          >
            <CometChatMessageReactions
              message={this.props.message}
              actionGenerated={this.props.actionGenerated}
            />
          </div>
        )
      }
    }

    let toolTipView = null
    if (this.state.isHovering) {
      toolTipView = (
        <CometChatMessageActions
          message={this.props.message}
          actionGenerated={this.props.actionGenerated}
        />
      )
    }

    let fileMessage = null
    if (
      this.props.message.data.hasOwnProperty('attachments') &&
      this.props.message.data.attachments.length
    ) {
      const fileName = this.props.message.data.attachments[0].name
      const fileUrl = this.props.message.data.attachments[0].url

      fileMessage = (
        <a
          href={fileUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="message__file"
        >
          <i css={iconStyle(fileIcon, this.context)}></i>
          <p>{fileName}</p>
        </a>
      )
    } else {
      const fileName = this.props.message.data.name || ''

      fileMessage = (
        <div className="message__file">
          <i css={iconStyle(fileIcon, this.context)}></i>
          <p>{fileName}</p>
        </div>
      )
    }

    return (
      <div
        css={messageContainerStyle()}
        className="sender__message__container message__file"
        onMouseEnter={this.handleMouseHover}
        onMouseLeave={this.handleMouseHover}
      >
        {toolTipView}

        <div css={messageWrapperStyle()} className="message__wrapper">
          <div
            css={messageFileWrapper(this.context)}
            className="message__file__wrapper"
          >
            {fileMessage}
          </div>
        </div>

        {messageReactions}

        <div css={messageInfoWrapperStyle()} className="message__info__wrapper">
          <CometChatThreadedMessageReplyCount
            message={this.props.message}
            actionGenerated={this.props.actionGenerated}
          />
          <CometChatReadReceipt message={this.props.message} />
        </div>
      </div>
    )
  }
}

// Specifies the default values for props:
CometChatSenderFileMessageBubble.defaultProps = {
  theme: theme,
  actionGenerated: () => {},
}

CometChatSenderFileMessageBubble.propTypes = {
  theme: PropTypes.object,
  actionGenerated: PropTypes.func.isRequired,
  message: PropTypes.object.isRequired,
}

export { CometChatSenderFileMessageBubble }
